import { pickBy, isNil } from "lodash"

/**
 * Request object for creating/replacing an advanced filter recipients batch
 * 
 * @description Creates a batch for an entity type. If notice_id is provided and a batch
 * already exists for that notice + entity type combination, the old batch is replaced.
 * The backend uses filter_criteria to fetch recipients from the D6+ API.
 * 
 * POST /communities/{communityId}/notices/advanced-filter-recipients/batch
 * 
 * @see https://d6group.atlassian.net/wiki/spaces/d6/pages/403341313/Portal+API+Advanced+Filter+Recipients+API
 */
class PostAdvancedFilterBatchRequest {

    /**
     * @param {Object} params
     * @param {string} params.entityType - 'parent', 'learner', or 'staff_member'
     * @param {Object} params.filterCriteria - The full filter state sent to D6+ to resolve recipients
     * @param {string} [params.noticeId] - Optional UUID to link batch to existing draft
     */
    constructor({ 
        entityType,
        filterCriteria,
        noticeId,
    }) {
        this.entityType = entityType
        this.filterCriteria = filterCriteria
        this.noticeId = noticeId
    }

    /**
     * Convert frontend entity type to API entity type
     * Frontend uses 'parents', 'learners', 'staff'
     * API uses 'parent', 'learner', 'staff_member'
     */
    _getApiEntityType = () => {
        switch (this.entityType) {
            case 'parents':
                return 'parent'
            case 'learners':
                return 'learner'
            case 'staff':
                return 'staff_member'
            default:
                return this.entityType
        }
    }

    getPayload = () => {
        const payload = {
            "entity_type": this._getApiEntityType(),
            "filter_criteria": this.filterCriteria,
            "notice_id": this.noticeId,
        }

        // Remove null/undefined values
        return pickBy(payload, (value) => !isNil(value))
    }
}

export default PostAdvancedFilterBatchRequest
